export default __webpack_public_path__ + "static/planningtablet-2ed33ae3fecb636913369bf8a5893b23.png";